export default __webpack_public_path__ + "static/media/volkihar-book.1a3da5bd.png";